import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `movimientoVerraco/imprimirMovimientoVerraco`, method: 'POST', body: values, token: token})
}
